import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Button,
} from '@mui/material';
import { IZone } from '../../../utils/entities/interface';
import { Visibility } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { lockWidth } from '../../../utils/helper';

const MAX_PINCODES_DISPLAY = 20;

export const ZoneList = ({ zones }: { zones: IZone[] }) => {
  const [expandedZones, setExpandedZones] = useState<string[]>([]);

  const toggleExpand = (zoneId: string) => {
    setExpandedZones((prev) =>
      prev.includes(zoneId)
        ? prev.filter((id) => id !== zoneId)
        : [...prev, zoneId],
    );
  };

  return (
    <TableContainer sx={{ scrollbarWidth: 'none', marginTop: 0 }}>
      <Table>
        <TableBody>
          {zones.map((zone) => {
            const isExpanded = expandedZones.includes(String(zone.id));
            return (
              <TableRow key={zone.id}>
                <TableCell sx={{ ...lockWidth(10) }}>
                  <input type="checkbox" />
                </TableCell>
                <TableCell sx={{ ...lockWidth(50) }}>{zone.name}</TableCell>
                <TableCell sx={{ ...lockWidth(200) }}>
                  {zone.pincodes
                    .slice(
                      0,
                      isExpanded ? zone.pincodes.length : MAX_PINCODES_DISPLAY,
                    )
                    .map((pin, index) => (
                      <span key={index}>
                        {pin}
                        {index < zone.pincodes.length - 1 ? ', ' : ''}
                      </span>
                    ))}
                  {zone.pincodes.length > MAX_PINCODES_DISPLAY &&
                    !isExpanded && (
                      <Button onClick={() => toggleExpand(String(zone.id))}>
                        {zone.pincodes.length - MAX_PINCODES_DISPLAY} more...
                      </Button>
                    )}
                  {isExpanded && (
                    <Button onClick={() => toggleExpand(String(zone.id))}>
                      Show less
                    </Button>
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    ...lockWidth(30),
                    textAlign: 'center',
                    color: zone.isDisabled ? '#FF6F61' : '#00BFFF',
                  }}
                >
                  {zone.isDisabled ? 'Disabled' : 'Enabled'}
                </TableCell>
                <TableCell sx={{ ...lockWidth(20), textAlign: 'center' }}>
                  <IconButton aria-label="view">
                    <Visibility />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
